<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card v-if="errorException">
      <v-row
        align="center"
        class="pa-3 ma-3"
      >
        <v-icon
          small
          color="orange darken-3"
        >
          report_problem
        </v-icon>
        <span class="orange--text text--darken-3 align-center">{{
          errorException
        }}</span>
        <v-spacer />
        <IconBtn
          icons="close"
          :large="true"
          color="grey darken-4"
          @click="close"
        />
      </v-row>
    </v-card>
    <v-card v-else>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <CustomTextField
              v-model="title"
              label="Найменування"
              :hide-details="true"
              :required="true"
              :error-messages="$v.title.$invalid ? errors.TITLE : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <SalesFunnelTypeSelect
              v-model="type"
              :multiple-select="false"
              label="Тип"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
    <div />
  </div>
</template>

<script>
import * as salesFunnelStagesApi from "../../backend/salesFunnelStagesApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import CustomTextField from "../../../components/CustomTextField.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";
import SalesFunnelTypeSelect from "../salesFunnelTypes/SalesFunnelTypesSelect.vue";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    CustomTextField,
    SalesFunnelTypeSelect,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    errorException: "",
    isChanged: false,
    title: "",
    type: null,
  }),
  validations: {
    title: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.title.$invalid;
    },
    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення стадії воронки продажів" : "Редагування стадії воронки продажів";
    },
    errors() {
      return {
        TITLE: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (this.id != 0) {
      salesFunnelStagesApi.getStage(this.id).then((data) => {
        this.title = data.title;
        this.type = data.type;
      });
    }
  },
  methods: {
    async save() {
      this.loading = true;
      const newEntity = {
        title: this.title,
        salesFunnelTypeId: this.type?.id,
      };
      if (this.id == 0) {
        await salesFunnelStagesApi
          .createStage(newEntity)
          .then(() => {
            this.$router.push({ path: "/crm-sales-funnel-stages" });
          });
      } else {
        await salesFunnelStagesApi.updateStage(this.id, newEntity);
        this.$notifySuccess();
      }
      this.loading = false;
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>